import React from "react";

const MapSVG = () => {
  return (
    <svg width="284" height="220" viewBox="0 0 284 220" fill="none" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink">
      <g clipPath="url(#clip0_1_718)">
        <g clipPath="url(#clip1_1_718)">
          <g clipPath="url(#clip2_1_718)">
            <path d="M245.09 131.33H38.5V208.05H245.09V131.33Z" fill="white" />
            <path d="M245.09 131.33H38.5V208.05H245.09V131.33Z" stroke="#141B34" strokeLinecap="round" strokeLinejoin="round" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M71 164.06L60.76 157.73L50.57 164.06H71Z"
              fill="#141B34"
              stroke="#141B34"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path fillRule="evenodd" clipRule="evenodd" d="M71 180.65V186.53H50.57V173.5" fill="white" />
            <path d="M71 180.65V186.53H50.57V173.5" stroke="#141B34" strokeLinecap="round" strokeLinejoin="round" />
            <path fillRule="evenodd" clipRule="evenodd" d="M50.57 170.5V164.06H71V176.65" fill="white" />
            <path d="M50.57 170.5V164.06H71V176.65" stroke="#141B34" strokeLinecap="round" strokeLinejoin="round" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M233.02 164.06L222.77 157.73L212.59 164.06H233.02Z"
              fill="#141B34"
              stroke="#141B34"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path fillRule="evenodd" clipRule="evenodd" d="M233.02 180.65V186.53H212.59V173.5" fill="white" />
            <path d="M233.02 180.65V186.53H212.59V173.5" stroke="#141B34" strokeLinecap="round" strokeLinejoin="round" />
            <path fillRule="evenodd" clipRule="evenodd" d="M212.59 170.5V164.06H233.02V176.65" fill="white" />
            <path d="M212.59 170.5V164.06H233.02V176.65" stroke="#141B34" strokeLinecap="round" strokeLinejoin="round" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M240.6 120.75C241.81 120.75 242.79 122.91 242.79 125.57C242.79 128.23 241.79 130.39 240.6 130.39C239.41 130.39 238.42 128.23 238.42 125.57C238.42 122.91 239.4 120.75 240.6 120.75Z"
              fill="#141B34"
            />
            <path d="M92.01 166.44H84.25V207.26H92.01V166.44Z" fill="#141B34" />
            <path d="M195.9 165.67H188.19V207.43H195.9V165.67Z" fill="#141B34" />
            <path d="M106.91 165.67H99.15V207.1H106.91V165.67Z" fill="#141B34" />
            <path d="M121.88 166.23H114.12V207.18H121.88V166.23Z" fill="#141B34" />
            <path d="M136.81 165.91H129.05V207.01H136.81V165.91Z" fill="#141B34" />
            <path d="M151.44 165.79H143.68V207.18H151.44V165.79Z" fill="#141B34" />
            <path d="M166.38 165.91H158.7V206.93H166.38V165.91Z" fill="#141B34" />
            <path d="M181.27 165.67H173.49V206.94H181.27V165.67Z" fill="#141B34" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M194.56 162.12L139.95 143.83L85.58 162.12H194.56Z"
              fill="#D2DAFA"
              stroke="#141B34"
              strokeWidth="0.69"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path d="M195.63 162.32H84.52V166.5H195.63V162.32Z" fill="white" stroke="#141B34" strokeLinecap="round" strokeLinejoin="round" />
            <path
              d="M140.1 144.23C141.398 144.23 142.45 141.96 142.45 139.16C142.45 136.36 141.398 134.09 140.1 134.09C138.802 134.09 137.75 136.36 137.75 139.16C137.75 141.96 138.802 144.23 140.1 144.23Z"
              fill="#141B34"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M76.36 111.19V108.5H74.93C74.46 106.22 71.34 104.87 67.93 104.5V99.8298C67.93 99.6098 67.61 99.4298 67.23 99.4298H67C67.2726 99.3691 67.5179 99.221 67.6984 99.0079C67.8789 98.7949 67.9849 98.5287 68 98.2498C67.9492 97.8948 67.7721 97.57 67.5012 97.335C67.2302 97.1001 66.8836 96.9707 66.525 96.9707C66.1664 96.9707 65.8198 97.1001 65.5488 97.335C65.2779 97.57 65.1008 97.8948 65.05 98.2498C65.0624 98.5161 65.1564 98.7721 65.3192 98.9831C65.4819 99.1942 65.7056 99.3501 65.96 99.4298H65.79C65.41 99.4298 65.09 99.6098 65.09 99.8298V104.43C61.49 104.64 58.25 105.96 58.09 108.5H56.75V111.19H58V128.65H56.6V131.35H76.21V128.65H75V111.19H76.36ZM71.16 124.19H61.4V113.12H71.16V124.19Z"
              fill="#141B34"
              stroke="#141B34"
              strokeWidth="0.78"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M227 111.19V108.5H225.58C225.1 106.22 221.99 104.87 218.58 104.5V99.83C218.58 99.61 218.27 99.43 217.88 99.43H217.71C217.964 99.3503 218.188 99.1944 218.351 98.9833C218.514 98.7723 218.608 98.5163 218.62 98.25C218.62 97.8522 218.462 97.4706 218.181 97.1893C217.899 96.908 217.518 96.75 217.12 96.75C216.722 96.75 216.341 96.908 216.059 97.1893C215.778 97.4706 215.62 97.8522 215.62 98.25C215.63 98.5171 215.722 98.7745 215.886 98.9861C216.049 99.1977 216.274 99.3529 216.53 99.43H216.35C215.97 99.43 215.66 99.61 215.66 99.83V104.43C212.05 104.64 208.81 105.96 208.66 108.5H207.39V111.19H208.63V128.65H207.24V131.35H226.85V128.65H225.63V111.19H227ZM221.8 124.19H212V113.12H221.76L221.8 124.19Z"
              fill="#141B34"
              stroke="#141B34"
              strokeWidth="0.78"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M42.78 120.43C44 120.43 45 122.58 45 125.25C45 127.92 44 130.06 42.81 130.06C41.62 130.06 40.62 127.91 40.62 125.25C40.62 122.59 41.57 120.43 42.78 120.43Z"
              fill="#141B34"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M126.31 91.4298C126.31 90.9998 125.63 90.8698 124.56 90.8398C124.16 90.8398 123.71 90.8398 123.23 90.8398H119.48C119.05 90.8398 118.67 90.8398 118.32 90.8398H118.25C117.14 90.8398 116.43 90.9898 116.43 91.4298C116.43 91.8698 117.15 92.2598 118.25 92.5298V115.29C117.13 115.56 116.4 115.96 116.4 116.4C116.4 117.18 118.58 116.97 121.3 116.97C124.02 116.97 126.3 117.18 126.3 116.4C126.3 115.98 125.63 115.59 124.58 115.32V92.5198C125.63 92.2498 126.31 91.8598 126.31 91.4298Z"
              fill="#D2DAFA"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M113.12 91.4899C113.12 91.0599 112.43 90.9299 111.37 90.8999C110.97 90.8999 110.53 90.8999 110.05 90.8999H105.05C103.95 90.8999 103.24 91.0499 103.24 91.4899C103.24 91.9299 103.95 92.3299 105.05 92.5899V115.35C103.94 115.62 103.21 116.02 103.21 116.46C103.21 117.24 105.39 117.03 108.11 117.03C110.83 117.03 113.11 117.24 113.11 116.46C113.11 116.04 112.44 115.65 111.39 115.38V92.5799C112.43 92.3099 113.12 91.9199 113.12 91.4899Z"
              fill="#D2DAFA"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M139.42 91.57C139.42 91.14 138.73 91.01 137.67 90.98C137.27 90.98 136.83 90.98 136.34 90.98H131.34C130.24 90.98 129.52 91.13 129.52 91.57C129.52 92.01 130.24 92.41 131.34 92.67V115.43C130.22 115.7 129.5 116.1 129.5 116.54C129.5 117.32 131.68 117.11 134.4 117.11C137.12 117.11 139.4 117.32 139.4 116.54C139.4 116.12 138.73 115.73 137.68 115.46V92.66C138.73 92.39 139.42 92 139.42 91.57Z"
              fill="#D2DAFA"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M152.55 91.4298C152.55 90.9998 151.86 90.8698 150.8 90.8398C150.41 90.8398 149.96 90.8398 149.47 90.8398H145.75C145.33 90.8398 144.95 90.8398 144.6 90.8398H144.52C143.42 90.8398 142.71 90.9898 142.71 91.4298C142.71 91.8698 143.42 92.2598 144.52 92.5298V115.29C143.41 115.56 142.68 115.96 142.68 116.4C142.68 117.18 144.86 116.97 147.58 116.97C150.3 116.97 152.58 117.18 152.58 116.4C152.58 115.98 151.91 115.59 150.86 115.32V92.5198C151.86 92.2498 152.55 91.8598 152.55 91.4298Z"
              fill="#D2DAFA"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M165.74 91.59C165.74 91.16 165.06 91.03 163.99 91C163.59 91 163.14 91 162.66 91H158.94C158.52 91 158.13 91 157.78 91H157.71C156.61 91 155.89 91.14 155.89 91.59C155.89 92.04 156.61 92.42 157.71 92.69V115.45C156.59 115.72 155.86 116.12 155.86 116.56C155.86 117.34 158.04 117.13 160.76 117.13C163.48 117.13 165.76 117.34 165.76 116.56C165.76 116.13 165.09 115.75 164.04 115.48V92.67C165.06 92.41 165.74 92 165.74 91.59Z"
              fill="#D2DAFA"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M177.08 115.38V92.5799C178.15 92.3099 178.83 91.9199 178.83 91.4899C178.83 91.0599 178.14 90.9299 177.08 90.8999C176.69 90.8999 176.24 90.8999 175.76 90.8999H170.76C169.66 90.8999 168.95 91.0499 168.95 91.4899C168.95 91.9299 169.66 92.3299 170.76 92.5899V115.35C169.65 115.62 168.92 116.02 168.92 116.46C168.92 117.24 171.1 117.03 173.82 117.03C176.54 117.03 178.82 117.24 178.82 116.46C178.8 116 178.13 115.65 177.08 115.38Z"
              fill="#D2DAFA"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M146.25 13.83C144.976 14.9323 143.434 15.6806 141.78 16V12.36L143.78 11.36L143.22 10.9L141.8 11.63V8.05H145.17V6.83H141.8V4H140.24V6.83H137.09V8.05H140.22V12.41L138.16 13.47L138.72 13.94L140.22 13.16V16C138.592 15.717 137.086 14.9504 135.9 13.8C135.9 15.58 137.85 17.08 140.52 17.21C139.04 17.41 137.92 18.37 137.92 19.51C137.92 20.81 139.35 21.86 141.12 21.86C142.89 21.86 144.32 20.81 144.32 19.51C144.32 18.21 143.11 17.35 141.54 17.19C144 17 146.1 15.48 146.25 13.83Z"
              fill="#141B34"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M141.15 39.8298C145.589 39.8305 149.983 40.7151 154.076 42.432C158.169 44.1489 161.879 46.6638 164.99 49.8298C171.348 56.2662 174.906 64.953 174.89 73.9998C174.89 86.2598 168.09 88.3998 158.21 88.3998C155.7 88.3998 152.99 88.2598 150.14 88.1098C146.98 87.9498 143.66 87.7798 140.25 87.7798C130.97 87.7798 122.74 89.0398 116.87 87.9498C115.748 87.745 114.654 87.4094 113.61 86.9498C109.69 85.2098 107.41 81.4898 107.41 73.9498C107.395 64.9091 110.954 56.2288 117.31 49.7998C120.42 46.6329 124.13 44.1175 128.224 42.4005C132.317 40.6835 136.711 39.7994 141.15 39.7998V39.8298Z"
              fill="#D2DAFA"
              stroke="#141B34"
              strokeWidth="0.69"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M104.62 72.6299C105.93 72.6299 107 74.2899 107 76.3399C107 78.3899 105.93 80.0499 104.62 80.0499C103.31 80.0499 102.23 78.3899 102.23 76.3399C102.23 74.2899 103.3 72.6299 104.62 72.6299Z"
              fill="#141B34"
            />
            <path d="M182.97 81.5H98.22V89.69H182.97V81.5Z" fill="#141B34" />
            <path d="M182.97 81.5H98.22V89.69H182.97V81.5Z" stroke="#141B34" strokeWidth="0.78" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M182.97 81.5H98.22V89.69H182.97V81.5Z" fill="#141B34" />
            <path d="M182.97 81.5H98.22V89.69H182.97V81.5Z" stroke="#141B34" strokeWidth="0.78" strokeLinecap="round" strokeLinejoin="round" />
            <path
              d="M182.97 81.5H98.22V89.69H182.97V81.5Z"
              fill="#141B34"
              stroke="#141B34"
              strokeWidth="0.78"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M147.73 27.0898C147.73 24.7398 144.73 21.5398 141.11 21.5498C137.49 21.5598 134.55 24.7598 134.56 27.1098C134.564 27.547 134.667 27.9776 134.86 28.3698V40.0898H147.42V28.3598H147.5C147.671 27.9592 147.75 27.5251 147.73 27.0898ZM141.08 38.4198C139.78 38.4198 138.73 36.5398 138.73 34.2098C138.73 31.8798 139.73 30.0098 141.08 30.0098C142.43 30.0098 143.42 31.8898 143.42 34.2098C143.42 36.5298 142.37 38.4198 141.08 38.4198Z"
              fill="#141B34"
              stroke="#141B34"
              strokeWidth="0.78"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M135.67 72.5498C136.99 72.5498 138.05 74.2098 138.05 76.2598C138.05 78.3098 137 79.9998 135.67 79.9998C134.34 79.9998 133.29 78.3398 133.29 76.2898C133.29 74.2398 134.36 72.5498 135.67 72.5498Z"
              fill="#141B34"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M125.47 72.6299C126.79 72.6299 127.86 74.2899 127.86 76.3399C127.86 78.3899 126.79 80.0499 125.47 80.0499C124.15 80.0499 123.09 78.3899 123.09 76.3399C123.09 74.2899 124.16 72.6299 125.47 72.6299Z"
              fill="#141B34"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M115.11 72.46C116.43 72.46 117.5 74.12 117.5 76.16C117.5 78.2 116.43 79.87 115.11 79.87C113.79 79.87 112.73 78.21 112.73 76.16C112.73 74.11 113.8 72.46 115.11 72.46Z"
              fill="#141B34"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M146.25 72.5498C147.56 72.5498 148.63 74.2098 148.63 76.2598C148.63 78.3098 147.56 79.9998 146.25 79.9998C144.94 79.9998 143.86 78.3398 143.86 76.2898C143.86 74.2398 144.93 72.5498 146.25 72.5498Z"
              fill="#141B34"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M166.55 72.5298C167.87 72.5298 168.93 74.1898 168.93 76.2298C168.93 78.2698 167.87 79.9398 166.55 79.9398C165.23 79.9398 164.17 78.2798 164.17 76.2298C164.17 74.1798 165.23 72.5298 166.55 72.5298Z"
              fill="#141B34"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M156.54 72.5498C157.86 72.5498 158.93 74.2098 158.93 76.2598C158.93 78.3098 157.86 79.9998 156.54 79.9998C155.22 79.9998 154.16 78.3398 154.16 76.2898C154.16 74.2398 155.23 72.5498 156.54 72.5498Z"
              fill="#141B34"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M176.73 72.6699C178.04 72.6699 179.11 74.3299 179.11 76.3799C179.11 78.4299 178.04 80.0899 176.73 80.0899C175.42 80.0899 174.34 78.4299 174.34 76.3799C174.34 74.3299 175.41 72.6699 176.73 72.6699Z"
              fill="#141B34"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M84.81 130.73L99.53 127.42H182.38L197.11 130.73H84.81Z"
              fill="#141B34"
              stroke="#141B34"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path d="M182.32 118.91H99.3V126.75H182.32V118.91Z" fill="#141B34" />
            <path d="M182.32 118.91H99.3V126.75H182.32V118.91Z" stroke="#141B34" strokeWidth="0.78" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M182.32 118.91H99.3V126.75H182.32V118.91Z" fill="#141B34" />
            <path d="M182.32 118.91H99.3V126.75H182.32V118.91Z" stroke="#141B34" strokeWidth="0.78" strokeLinecap="round" strokeLinejoin="round" />
            <path
              d="M182.32 118.91H99.3V126.75H182.32V118.91Z"
              fill="#141B34"
              stroke="#141B34"
              strokeWidth="0.78"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path fillRule="evenodd" clipRule="evenodd" d="M84.47 207.75L195.99 207.56L199.23 220.06H80.8L84.47 207.75Z" fill="#141B34" />
            <mask id="mask0_1_718" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="80" y="207" width="120" height="14">
              <path d="M84.47 207.75L195.99 207.56L199.23 220.06H80.8L84.47 207.75Z" fill="white" />
            </mask>
            <g mask="url(#mask0_1_718)">
              <rect x="199.23" y="207.56" width="12.33" height="115.83" transform="rotate(90 199.23 207.56)" fill="url(#pattern0_1_718)" />
            </g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M84.47 207.75L195.99 207.56L199.23 220.06H80.8L84.47 207.75Z"
              stroke="#141B34"
              strokeWidth="0.78"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M84.47 207.75L195.99 207.56L199.23 220.06H80.8L84.47 207.75Z"
              fill="#141B34"
              stroke="#141B34"
              strokeWidth="0.78"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M87.25 149.23C88.55 149.23 89.6 151.5 89.6 154.3C89.6 157.1 88.55 159.37 87.25 159.37C85.95 159.37 84.91 157.1 84.91 154.3C84.91 151.5 86 149.23 87.25 149.23Z"
              fill="#141B34"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M193.89 149.34C195.19 149.34 196.24 151.61 196.24 154.41C196.24 157.21 195.19 159.48 193.89 159.48C192.59 159.48 191.54 157.21 191.54 154.41C191.54 151.61 192.59 149.34 193.89 149.34Z"
              fill="#141B34"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M183.64 71.6602C184.85 71.6602 185.83 73.8102 185.83 76.4702C185.83 79.1302 184.83 81.2902 183.64 81.2902C182.45 81.2902 181.46 79.1302 181.46 76.4702C181.46 73.8102 182.43 71.6602 183.64 71.6602Z"
              fill="#141B34"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M97.83 71.8799C99 71.8799 100 73.9999 100 76.6999C100 79.3999 99 81.5199 97.82 81.5199C96.64 81.5199 95.63 79.3599 95.63 76.6999C95.63 74.0399 96.62 71.8799 97.83 71.8799Z"
              fill="#141B34"
            />
          </g>
        </g>
      </g>
      <defs>
        <pattern id="pattern0_1_718" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref="#image0_1_718" transform="scale(0.00729927 0.000777001)" />
        </pattern>
        <clipPath id="clip0_1_718">
          <rect width="284" height="220" fill="white" />
        </clipPath>
        <clipPath id="clip1_1_718">
          <rect width="207.59" height="216.45" fill="white" transform="translate(38 4)" />
        </clipPath>
        <clipPath id="clip2_1_718">
          <rect width="207.59" height="216.45" fill="white" transform="translate(38 4)" />
        </clipPath>
        <image
          id="image0_1_718"
          width="137"
          height="1287"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
};

export default MapSVG;
